export default __webpack_public_path__ + "img/1f7a6e41305db59b7d3cab162402a32f.svg";